import { isIOSWebview } from '@hozana/screen/functions/isIOSWebview'

import { useIsHydrated } from './useIsHydrated'

export const useIsNative = () => useIsHydrated() && isIOSWebview()
